"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassPerformanceSerializer = void 0;
class ClassPerformanceSerializer {
    constructor(assessmentsPerformanceSerializer) {
        this.assessmentsPerformanceSerializer = assessmentsPerformanceSerializer;
    }
    serializeOne(data) {
        return {
            contextId: data.contextId,
            assessmentsPerformance: (data.assessmentsPerformance || []).map((performance) => this.assessmentsPerformanceSerializer.serializeOne(performance)),
        };
    }
}
exports.ClassPerformanceSerializer = ClassPerformanceSerializer;
//# sourceMappingURL=class-performance.serializer.js.map